// extracted by mini-css-extract-plugin
module.exports = {"bleed":"checkout-form-light_bleed__J4c2B","column":"checkout-form-light_column__uwHxR"};